/**
 * Ressursfanens fire visninger, som verdier.
 *
 * EGEN FIL AV GRUNNEN `people-tabs.ts` NEVNER: ruta validerer `?view=` i kanten, og da den
 * importerte lista fra `ResourcesPage.tsx` ble hele siden — tabeller, kart, dialoger — en del av
 * ruterens hovedbunt, lastet før `/v1/me/bootstrap` i det hele tatt kunne starte.
 */
export const RESOURCES_VIEWS = ['list', 'week', 'day', 'map'] as const;
export type ResourcesView = (typeof RESOURCES_VIEWS)[number];
